import React, { useContext } from "react";

import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import SpotterImage from "./images/SPOT-0222.png";

import { UIContext } from "../../context/UIContext";

const useStyles = makeStyles({
  trialForm: {
    background: "transparent",
    boxShadow: "none",
    color: "#FFF",
    textAlign: "left",
    width: "52.5vw",
    "@media only screen and (max-width: 1400px)": {
      width: "60vw"
    },
    "@media only screen and (max-width: 1200px)": {
      width: "70vw"
    }
  },
  checkIcon: {
    color: "#7DCE6C",
    transform: "translate(0px, 5px)"
  },
  dialogTitle: {
    background: "#43475B",
    fontSize: "40px",
    fontWeight: "bold",
    padding: "1em 2em 1em 1.5em",
    textAlign: "left",
    "@media only screen and (max-width: 650px)": {
      fontSize: "30px"
    },
    "@media only screen and (max-width: 450px)": {
      fontSize: "20px"
    }
  },
  modalText: {
    display: "inline",
    fontSize: "1.2em",
    "@media only screen and (max-width: 1500px)": {
      fontSize: "1em"
    }
  },
  modalTextFooter: {
    clear: "both",
    display: "inline-block",
    fontSize: "1.2em",
    marginTop: "5vh",
    "@media only screen and (max-width: 1500px)": {
      fontSize: "1em"
    },
    "@media only screen and (max-width: 1000px)": {
      marginTop: "2vh"
    }
  },
  modalTextTitle: {
    fontSize: "1.5em",
    fontWeight: "bold",
    marginBottom: "1em",
    "@media only screen and (max-width: 1500px)": {
      fontSize: "1.2em"
    }
  },
  spotterImg: {
    float: "right",
    width: "374px",
    "@media only screen and (max-width: 1000px)": {
      float: "none"
    }
  },
  title: {
    fontSize: 14
  },
  trialFeaturesList: {
    float: "left",
    padding: "0"
  }
});

const RequestAccess = ({ handleClose }) => {
  const classes = useStyles();
  const { setModalState } = useContext(UIContext);

  return (
    <React.Fragment>
      <DialogTitle
        id="responsive-dialog-title"
        className={classes.dialogTitle}
        disableTypography={true}
      >
        {"What you’ll get"}
        <Button
          style={{ float: "right", transform: "translate(40px, 0)" }}
          onClick={handleClose}
        >
          <CloseIcon style={{ color: "#FFF", transform: "scale(1.8)" }} />
        </Button>
      </DialogTitle>
      <DialogContent
        style={{ background: "#33374B", padding: "2em 4em 4em 4em" }}
      >
        <Paper className={classes.trialForm}>
          <img
            className={classes.spotterImg}
            src={SpotterImage}
            alt="Spotter-0222 in the Ocean"
          />
          <Typography variant="subtitle1" className={classes.modalTextTitle}>
            30-day free access to Sofar API
          </Typography>
          <List className={classes.trialFeaturesList}>
            <ListItem style={{ padding: "0" }}>
              <ListItemText>
                <CheckIcon className={classes.checkIcon} />{" "}
                <Typography variant="subtitle1" className={classes.modalText}>
                  Full Marine Weather API functionality
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem style={{ padding: "0" }}>
              <ListItemText>
                <CheckIcon className={classes.checkIcon} />{" "}
                <Typography variant="subtitle1" className={classes.modalText}>
                  Wave Spectra API functionality at at a preset location
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem style={{ padding: "0" }}>
              <ListItemText>
                <CheckIcon className={classes.checkIcon} />{" "}
                <Typography variant="subtitle1" className={classes.modalText}>
                  Spotter Data API access to a drifting Spotter
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem style={{ padding: "0", marginTop: "20px" }}>
              <ListItemText>
                <Typography
                  variant="subtitle1"
                  className={classes.modalText}
                  style={{ marginLeft: "25px" }}
                >
                  More API capabilities can be seen{" "}
                  <a
                    href="https://docs.sofarocean.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#228CBD", textDecoration: "none" }}
                  >
                    here
                  </a>
                  .
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="subtitle1" className={classes.modalTextFooter}>
            You’ll receive a unique API token that will allow full access to
            one of our free-floating ocean observational buoys. It is the perfect
            platform to evaluate and understand the full power of the Sofar API.
            At any point you can choose to purchase access to more Spotters,
            or the entire grid.
          </Typography>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#228CBD",
              borderRadius: "2px",
              color: "#FFF",
              display: "block",
              fontSize: "0.9em",
              fontWeight: "bold",
              padding: "1em 3em 1em 3em",
              marginTop: "3vh",
              textTransform: "none"
            }}
            onClick={() => setModalState(2)}
          >
            Continue
          </Button>
        </Paper>
      </DialogContent>
    </React.Fragment>
  );
};

export default RequestAccess;
